import { types } from 'mobx-state-tree'

const BasePersonModel = {
  id: types.identifier,
  cardNameF: types.maybeNull(types.string),
  cardNameS: types.maybeNull(types.string),
}

export default BasePersonModel
